import { Link } from 'react-router-dom';
import Button from '../shared/Button.jsx';
import Seo from '../seo/Seo.jsx';
import { metaFor } from '../seo/routes.js';

export default function NotFound() {
  return (
    <>
      <Seo {...metaFor('/404')} path="/404" />

      <section className="mx-auto flex min-h-[70vh] max-w-[640px] flex-col items-center justify-center px-5 text-center">
        <p className="font-hand text-2xl text-coral">A wrong turn</p>
        <h1 className="mt-2 font-display text-[clamp(34px,6vw,64px)] font-extrabold leading-[1.02] text-forest">
          We could not find that page
        </h1>
        <p className="mt-4 text-pretty text-lg leading-[1.6] text-ink-soft">
          It may have moved, or the link may have a typo in it. The homepage has
          everything — programmes, teachers, and how to apply.
        </p>

        <div className="mt-8 flex flex-wrap justify-center gap-3.5">
          <Button as={Link} to="/" variant="primary">
            Back to the homepage
          </Button>
          <Button as={Link} to="/#admissions" variant="outlineFlat">
            Start an enquiry
          </Button>
        </div>
      </section>
    </>
  );
}
